// Lightweight toast store — Svelte writable + helpers.
import { writable } from 'svelte/store';

let nextId = 1;
export const toasts = writable([]);

function push(kind, message, opts = {}) {
    const id = nextId++;
    const ttl = opts.ttl ?? (kind === 'error' ? 6000 : 3500);
    toasts.update(list => [...list, {
        id,
        kind,
        message,
        action: opts.action,    // optional { label, run }
        title: opts.title,
        ttl
    }]);
    if (ttl > 0) {
        setTimeout(() => dismiss(id), ttl);
    }
    return id;
}

export function dismiss(id) {
    toasts.update(list => list.filter(t => t.id !== id));
}

export const toast = {
    success: (msg, opts) => push('success', msg, opts),
    error:   (msg, opts) => push('error',   msg, opts),
    info:    (msg, opts) => push('info',    msg, opts),
    warning: (msg, opts) => push('warning', msg, opts)
};
